<template>
  <div ref="input" class="input" :class="{full: input.full_width}">
    <label class="optionalPosition">{{input.label}} <p class="optional" v-if="input.optional">(optional)</p> </label>
    <textarea v-model="answer" :type="input.type" @input="assertMaxChars()" @keyup="saveAnswer" />
    <h6>{{this.answer.length}}/150</h6>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      answer: null

    };
  },
  mounted() {},
  created() {
    this.answer = this.input.value;
  },
  firestore() {
    return {};
  },
  methods: {
    assertMaxChars(){
      if (this.answer.length >= 150) {
            this.answer = this.answer.substring(0,150);
        }
    },
    
    saveAnswer(e) {      
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    }
  },
  watch: {}
};
</script>

<style scoped lang='scss'>
textarea {
  resize: none;
  max-width: 100%;
  min-width: 100%;
  font-family: "Open Sans", sans-serif;
}
</style>
